import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { toast } from 'react-toastify';
import { Category } from '../types';

const createCategory = (category: Category) =>
  api.post(`/categories`, category);

export const useCreateCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['create-category'],
    mutationFn: createCategory,
    onSuccess: () => {
      toast.success('Category created successfully');

      queryClient.invalidateQueries({
        queryKey: ['categories'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
